import {generateColors} from '@mantine/colors-generator'
import {
   Accordion,
   AppShell,
   Avatar,
   Badge,
   Button,
   createTheme,
   Divider,
   Group,
   Modal,
   MultiSelect,
   NativeSelect,
   Notification,
   Radio,
   RadioGroup,
   Select,
   Skeleton,
   Table,
   Tabs,
   Text,
   Textarea,
   TextInput
} from '@mantine/core'
import {DateInput} from '@mantine/dates'
import {siteAccentHex, sitePrimaryHex} from '@/constants/site-brand'

export const getTheme = () => {
   return createTheme({
      fontFamily: 'Nunito, sans-serif',
      fontSmoothing: true,
      autoContrast: true,
      defaultRadius: 'md',
      primaryShade: 9,
      focusRing: 'never',
      focusClassName: 'clean-park-focus-ring',
      black: sitePrimaryHex,
      white: '#ffffff',
      colors: {
         primary: generateColors('#00213f'),
         secondary: generateColors(siteAccentHex),
         tertiary: generateColors('#3674b8'),
         title: generateColors('#4884f5'),
         description: generateColors('#e0ecff'),
         support: generateColors('#a2c2f7'),
         red: generateColors('#f96139'),
         gray: generateColors('#F8F8F8'),
         dark: generateColors('#292A27')
      },
      components: {
         AppShell: AppShell.extend({
            styles: {
               header: {
                  borderColor: '#eeeeee'
               },
               navbar: {
                  borderColor: '#eeeeee'
               }
            }
         }),
         Modal: Modal.extend({
            defaultProps: {
               size: 'lg',
               withCloseButton: false,
               closeOnClickOutside: false,
               transitionProps: {
                  transition: 'slide-down',
                  duration: 400
               }
            },
            styles: {
               root: {
                  boxShadow: 'none'
               }
            }
         }),
         Group: Group.extend({
            defaultProps: {
               gap: 'sm',
               align: 'center'
            }
         }),
         Text: Text.extend({
            defaultProps: {
               c: 'primary',
               fw: 450,
               size: 'md'
            }
         }),
         InputWrapper: {
            styles: () => ({
               label: {
                  color: 'grey',
                  fontSize: 13,
                  fontWeight: 450,
                  marginBottom: 3,
                  marginLeft: 4
               }
            })
         },
         TextInput: TextInput.extend({
            defaultProps: {
               fw: 400,
               variant: 'filled',
               size: 'md'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         Textarea: Textarea.extend({
            defaultProps: {
               fw: 400,
               variant: 'filled',
               size: 'md'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         Radio: Radio.extend({
            defaultProps: {
               fw: 400,
               variant: 'filled',
               color: 'secondary'
            }
         }),
         RadioGroup: RadioGroup.extend({
            defaultProps: {
               fw: 400,
               size: 'xl',
               variant: 'filled',
               color: 'secondary'
            }
         }),
         NativeSelect: NativeSelect.extend({
            defaultProps: {
               fw: 400,
               variant: 'filled',
               size: 'md'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         Select: Select.extend({
            defaultProps: {
               fw: 400,
               variant: 'filled',
               size: 'md',
               checkIconPosition: 'right'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         MultiSelect: MultiSelect.extend({
            defaultProps: {
               fw: 400,
               size: 'md',
               variant: 'filled',
               checkIconPosition: 'right'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         DateInput: DateInput.extend({
            defaultProps: {
               fw: 400,
               size: 'md',
               variant: 'filled'
            },
            styles: {
               input: {
                  backgroundColor: '#f8f8f8'
               }
            }
         }),
         Avatar: Avatar.extend({
            styles: {
               placeholder: {
                  fontWeight: 500
               }
            }
         }),
         Badge: Badge.extend({
            defaultProps: {
               radius: 'xl'
            }
         }),
         Button: Button.extend({
            defaultProps: {
               fw: 450,
               fz: 'lg',
               loaderProps: {
                  type: 'oval',
                  color: 'primary'
               }
            }
         }),
         Notification: Notification.extend({
            styles: {
               description: {
                  fontWeight: 500,
                  fontSize: '15px'
               }
            }
         }),
         Skeleton: Skeleton.extend({
            styles: () => ({
               root: {
                  '&[data-visible]::after': {
                     backgroundColor: '#f8f8f8'
                  }
               }
            })
         }),
         Tabs: Tabs.extend({
            styles: {
               tab: {
                  backgroundColor: '#ffffff00'
               }
            }
         }),
         Table: Table.extend({
            styles: {
               td: {
                  fontWeight: 500,
                  fontSize: 16
               }
            }
         }),
         Divider: Divider.extend({
            defaultProps: {
               color: '#f2f2f2'
            }
         }),
         Accordion: Accordion.extend({
            defaultProps: {
               py: '20px'
            },
            styles: {
               control: {
                  backgroundColor: '#f8f8f8'
               },
               item: {
                  borderColor: '#ebebeb'
               }
            }
         })
      }
   })
}
